import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu as MenuIcon } from "@mui/icons-material";
import {
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import logo from "../../assets/logo_al_ansarr.png";
import { APP_PATH, DEFAULT_BLUE } from "../constant";
import { getNavItemStyles } from "./helpers";

function ResponsiveAppBar() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleClose}
    >
      <Link to={APP_PATH.LOGIN} style={{ textDecoration: "none" }}>
        <MenuItem sx={{ color: "white" }} onClick={handleClose}>
          <Typography color="primary">Connexion</Typography>
        </MenuItem>
      </Link>
      <Link to={APP_PATH.REGISTRATION} style={{ textDecoration: "none" }}>
        <MenuItem sx={{ color: "white" }} onClick={handleClose}>
          <Typography color="primary">Créer un compte</Typography>
        </MenuItem>
      </Link>
    </Menu>
  );

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: "center",
        backgroundColor: DEFAULT_BLUE,
        height: "100%",
      }}
    >
      <Link to={APP_PATH.HOME}>
        <img src={logo} alt="An-Ansaar Logo" style={{ height: "150px" }} />
      </Link>
      <List>
        <ListItem
          component={NavLink}
          to={APP_PATH.HOME}
          sx={getNavItemStyles(APP_PATH.HOME, location.pathname)}
        >
          <ListItemText primary="Accueil" />
        </ListItem>
        <ListItem
          component={NavLink}
          to={APP_PATH.PROGRAM}
          sx={getNavItemStyles(APP_PATH.PROGRAM, location.pathname)}
        >
          <ListItemText primary="Programme" />
        </ListItem>
        <ListItem
          component={NavLink}
          to={APP_PATH.PRICING}
          sx={getNavItemStyles(APP_PATH.PRICING, location.pathname)}
        >
          <ListItemText primary="Tarifs" />
        </ListItem>
        <ListItem
          component={NavLink}
          to={APP_PATH.RULES}
          sx={getNavItemStyles(APP_PATH.RULES, location.pathname)}
        >
          <ListItemText primary="Règlement" />
        </ListItem>
        <ListItem
          component={NavLink}
          to={APP_PATH.ABOUT}
          sx={getNavItemStyles(APP_PATH.ABOUT, location.pathname)}
        >
          <ListItemText primary="A propos de" />
        </ListItem>
        <ListItem
          component={NavLink}
          to={APP_PATH.CONTACT}
          sx={getNavItemStyles(APP_PATH.CONTACT, location.pathname)}
        >
          <ListItemText primary="Nous contacter" />
        </ListItem>
        <ListItem
          component={NavLink}
          to={APP_PATH.SUBSCRIBE}
          sx={getNavItemStyles(APP_PATH.SUBSCRIBE, location.pathname)}
        >
          <ListItemText primary="S'inscrire" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: DEFAULT_BLUE,
          height: "64px",
          top: "45px",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            height: "100%",
            position: "relative",
          }}
        >
          {!isMobile && (
            <NavLink
              to={APP_PATH.HOME}
              style={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "120px",
                  position: "absolute",
                  top: "-35px",
                  left: "0",
                  backgroundColor: DEFAULT_BLUE,
                  borderRadius: "0 0 50% 50%",
                  paddingBottom: "15px",
                }}
              >
                <img
                  src={logo}
                  alt="An-Ansaar Logo"
                  style={{
                    height: "130px",
                    paddingLeft: "5px",
                  }}
                />
              </div>
            </NavLink>
          )}

          {isMobile ? (
            <Box display="flex" alignItems="center">
              <IconButton
                color="inherit"
                edge="start"
                aria-label="open drawer"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
              <Link to={APP_PATH.HOME} style={{ textDecoration: "none" }}>
                <Typography variant="h6" sx={{ ml: 1, color: "white" }}>
                  Institut Al-Ansarr
                </Typography>
              </Link>
              <Drawer
                anchor="left"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{ zIndex: 3000 }}
              >
                {drawer}
              </Drawer>
            </Box>
          ) : (
            <div>
              <NavLink to={APP_PATH.PROGRAM}>
                <Button
                  sx={getNavItemStyles(APP_PATH.PROGRAM, location.pathname)}
                >
                  Programme
                </Button>
              </NavLink>
              <NavLink to={APP_PATH.PRICING}>
                <Button
                  sx={getNavItemStyles(APP_PATH.PRICING, location.pathname)}
                >
                  Tarifs
                </Button>
              </NavLink>
              <NavLink to={APP_PATH.RULES}>
                <Button
                  sx={getNavItemStyles(APP_PATH.RULES, location.pathname)}
                >
                  Règlement
                </Button>
              </NavLink>
              <NavLink to={APP_PATH.ABOUT}>
                <Button
                  sx={getNavItemStyles(APP_PATH.ABOUT, location.pathname)}
                >
                  A propos de
                </Button>
              </NavLink>
              <NavLink to={APP_PATH.CONTACT}>
                <Button
                  sx={getNavItemStyles(APP_PATH.CONTACT, location.pathname)}
                >
                  Nous contacter
                </Button>
              </NavLink>
              <NavLink to={APP_PATH.SUBSCRIBE}>
                <Button
                  sx={getNavItemStyles(APP_PATH.SUBSCRIBE, location.pathname)}
                >
                  Inscription
                </Button>
              </NavLink>
              {/* <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton> */}
            </div>
          )}
        </Toolbar>
      </AppBar>
      {/* {renderMenu} */}
    </Box>
  );
}

export default ResponsiveAppBar;
